export default __webpack_public_path__ + "static/media/Exterior12.4a11ee39.jpg";